<!-- Dialog for successful submission -->
<h2 mat-dialog-title style="font-weight:bold; color:#003865">Success!</h2>

<!-- Showcase the record that was added/removed and whether it was added or removed (e.g., "{{submittedRecord}} was {{actionType}} successfully") -->
<mat-dialog-content class="mat-typography" style="color:#003865">
    <h3>"{{submittedRecord}}" was {{actionType}} successfully.</h3>
</mat-dialog-content>

<!-- Close button -->
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
